import { useEffect, useState } from "react";
import * as configUtils from "util/config";

export const useTaxThubanDocuments = () => {
    const [thubanCodeDefault, setThubanCodeDefault] = useState("");
    const [thubanCodeGanancias, setThubanCodeGanancias] = useState("");
    const [thubanCodeOtrosCertificados, setThubanCodeOtrosCertificados] = useState("");
    const [thubanCodeIIBBlocal, setThubanCodeIIBBlocal] = useState("");
    const [thubanCodeIIBBMultilateral, setThubanCodeIIBBMultilateral] = useState("");
    const [thubanCodeIIBBExento, setThubanCodeIIBBExento] = useState("");
    const [thubanCodeOtrosCertificadosIIBBLocal, setThubanCodeOtrosCertificadosIIBBLocal] = useState("");
    const [thubanCodeOtrosCertificadosIIBBMult, setThubanCodeOtrosCertificadosIIBBMult] = useState("");
    const [thubanCodeOtrosCertificadosIIBBExento, setThubanCodeOtrosCertificadosIIBBExento] = useState("");
    const [thubanCodeExentoImpSello, setThubanCodeExentoImpSello] = useState("");
    const [thubanCodeIvaNoRetencion, setThubanCodeIvaNoRetencion] = useState("");
    const [thubanCodeDNIFrenteRL, setThubanCodeDNIFrenteRL] = useState("");
    const [thubanCodeDNIDorsoRL, setThubanCodeDNIDorsoRL] = useState("");

    useEffect(() => {
        const defaultCode = configUtils.get("onboarding.thuban.defaultCode", "0000");
        const ganancias = configUtils.get("onboarding.thuban.code.impuesto_ganancias", "0027");
        const otrosCertificados = configUtils.get("onboarding.thuban.code.otros_certificados", "0028");
        const iibbLocal = configUtils.get("onboarding.thuban.code.iibb_convenio_local", "0029");
        const iibbMultilateral = configUtils.get("onboarding.thuban.code.iibb_convenio_multilateral", "0031");
        const iibbExento = configUtils.get("onboarding.thuban.code.iibb_certificado_exento", "0A34");
        const otrosCertificadosIIBBLocal = configUtils.get(
            "onboarding.thuban.code.otros_certificados-iibblocal",
            "0030",
        );
        const otrosCertificadosIIBBMultilateral = configUtils.get(
            "onboarding.thuban.code.otros_certificados-iibbmultilateral",
            "0032",
        );
        const otrosCertificadosIIBBExento = configUtils.get("onboarding.thuban.code.otros_iibb_exento", "0B34");
        const exentoImpSello = configUtils.get("onboarding.thuban.code.exento_impuesto_sello", "0035");
        const ivaNoRetencion = configUtils.get("onboarding.thuban.code.iva_no_retencion", "0026");

        const dniFrenteRL = configUtils.get("onboarding.thuban.code.dni.frente.RL", "0A10");
        const dniDorsoRL = configUtils.get("onboarding.thuban.code.dni.dorso.RL", "0B10");

        setThubanCodeGanancias(ganancias);
        setThubanCodeOtrosCertificados(otrosCertificados);
        setThubanCodeIIBBlocal(iibbLocal);
        setThubanCodeIIBBMultilateral(iibbMultilateral);
        setThubanCodeIIBBExento(iibbExento);
        setThubanCodeOtrosCertificadosIIBBLocal(otrosCertificadosIIBBLocal);
        setThubanCodeOtrosCertificadosIIBBMult(otrosCertificadosIIBBMultilateral);
        setThubanCodeOtrosCertificadosIIBBExento(otrosCertificadosIIBBExento);
        setThubanCodeExentoImpSello(exentoImpSello);
        setThubanCodeIvaNoRetencion(ivaNoRetencion);
        setThubanCodeDefault(defaultCode);
        setThubanCodeDNIFrenteRL(dniFrenteRL);
        setThubanCodeDNIDorsoRL(dniDorsoRL);
    }, []);

    return {
        thubanCodeDefault,
        thubanCodeGanancias,
        thubanCodeOtrosCertificados,
        thubanCodeIIBBlocal,
        thubanCodeIIBBMultilateral,
        thubanCodeIIBBExento,
        thubanCodeOtrosCertificadosIIBBLocal,
        thubanCodeOtrosCertificadosIIBBMult,
        thubanCodeOtrosCertificadosIIBBExento,
        thubanCodeExentoImpSello,
        thubanCodeIvaNoRetencion,
        thubanCodeDNIFrenteRL,
        thubanCodeDNIDorsoRL,
    };
};

export default useTaxThubanDocuments;
